import { DialogService, GridAction } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { AccSessionViewerDialog } from '../../../../../../ui/widget';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { DirectlyAssignSpecialistDialog, DirectlyAssignSpecialistDialogData } from '../directly-assign-specialist-dialog/directly-assign-specialist.dialog';
import { SessionTopicAssignmentByEvent } from '../session-assignments.part';

export function getActions(service: VolunteeringAreaService, dialogService: DialogService) {

	const actions: GridAction<SessionTopicAssignmentByEvent>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Sign-ups',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccSessionViewerDialog, { data: { accSessionId: rows[0]!.accSessionId, topicId: rows[0]!.topicId } }, 700, 600);
				await service.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-user-plus',
			label: 'Directly Assign Specialist',
			isEnabled: rows => !!rows.length && service.staffPermissions().canDirectlyAssignSpecialist,
			execute: async rows => {
				const r = rows[0]!;
				const dialogData: DirectlyAssignSpecialistDialogData = {
					accId: r.accId,
					topicId: r.topicId,
					topicName: r.topicName,
					languageId: r.languageId,
					language: r.languageId === LanguageId.Espanol ? 'Spanish' : 'English'
				}
				await dialogService.showCustom(DirectlyAssignSpecialistDialog, { data: dialogData }, 600, 550);
				await service.reloadData();
			}
		},
	];

	return actions;
}